const backendUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_DEV : process.env.REACT_APP_API
// general
export const statsUrl = backendUrl + "stats/"
export const yearlyStatsUrl = backendUrl + "stats/yearly/"
export const getInfoUrl = backendUrl + "getinfo/"

// data storage
export const addInfoDataStorageUrl = backendUrl + "addInfo/"

// testimony
export const narrativeUrl = backendUrl + "narrative/"
export const testimonyUrl = backendUrl + "testimony/"
export const testimonyFilterUrl = backendUrl + "testimony/filter/"
export const testimonyFormOptionsUrl = backendUrl + "testimony/formoptions/"
// testimony victim
export const victimUrl = backendUrl + "victim/"
export const victimNarrativeUrl = backendUrl + "victim/narrative/"
export const victimDocumentUrl = backendUrl + "victim/document/"
export const victimTagsUrl = backendUrl + "victim/tags/"
export const victimAssessmentUrl = backendUrl + "victim/assessment/"
export const victimImageUrl = backendUrl + "victim/image/"
export const victimDetentionUrl = backendUrl + "victim/detention/"
export const victimSourceUrl = backendUrl + "victim/source/"
export const victimContactUrl = backendUrl + "victim/contact/"
export const victimConsentUrl = backendUrl + "victim/consents/"
export const victimAddressUrl = backendUrl + "victim/address/"
export const victimHealthUrl = backendUrl + "victim/health/"
export const victimDataUrl = backendUrl + "victim/data/"
export const victimTravelUrl = backendUrl + "victim/travel/"
export const victimSummaryUrl = backendUrl + "victim/summary/"
export const victimOccupationUrl = backendUrl + "victim/occupation/"
export const victimVideoUrl = backendUrl + "victim/video/"
export const victimVerifiedUrl = backendUrl + "victim/verified/"
export const victimRemoveUrl = backendUrl + "victim/remove/"

// internment
export const internmentUrl = backendUrl + "internment/"
export const internmentMetaDataUrl = backendUrl + "internment/metadata/"
export const internmentMetaDataFilesUrl = backendUrl + "internment/metadata/files/"
export const internmentTypesUrl = backendUrl + "internment/types/"
export const internmentFilterUrl = backendUrl + "internment/filter/"

// todo
export const taskUrl = backendUrl + "task/"
export const taskEditUrl = backendUrl + "task/edit/"
export const taskChangeUrl = backendUrl + "task/change/"
export const taskArchivedUrl = backendUrl + "task/archived/"

// location
export const crowdLocationUrl = backendUrl + "crowd/location/"

// evidence
export const addEvidenceUrl = backendUrl + "addevidence/"